import { css } from '../utils.js';

const themedStyles = css`
	.VirtualizedSelectFocusedOption {
	  background-color: ${props => props.theme.background_content};
	}
`
export default themedStyles;
